module.exports = __webpack_public_path__ + "img/QN900B.0427a427.png";